{
  "access": {
    "configure_provider": "Configure {{provider}}",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "close_notice": "Close notice",
    "setup_steps": "Setup progress",
    "business": "Business",
    "location": "Location",
    "hours_review": "Hours & review",
    "review_setup": "Review your setup",
    "checkout_help": "Your setup is saved before checkout. If checkout fails, return here and try again.",
    "setup_help": "Set up your business, location and working hours. You can go back to check your details before starting your trial.",
    "invoices_unavailable": "Invoice history is temporarily unavailable. Try again later.",
    "edit_member": "Edit access",
    "member_impact": "Review the role and location access before saving. Existing work may require an explicit handoff.",
    "team_limit": "The current plan has no available team places. Manage active resources or review your plan before inviting.",
    "website_content": "Content",
    "website_locations": "Locations",
    "website_domain": "Domain",
    "review_changes": "Review changes",
    "resource_review": "Review retention and handoffs",
    "resource_impact": "Only the selected staff and locations remain active. Explicit handoffs are checked again when you confirm. Historical work stays available under existing access rules.",
    "retained_count": "{{staff}} team members · {{locations}} locations retained",
    "no_change_yet": "No changes have been saved yet.",
    "pending_decision": "Your decision is needed",
    "set_password_later": "Set a password later",
    "optional_password": "Your request is already submitted. A password is optional and lets you return to your customer history.",
    "contact_vehicle": "Contact & vehicle",
    "service_time": "Service & preferred time",
    "review_verify": "Review & verify email",
    "enquiry_review_help": "Check your details, then save the private draft and verify your email to submit the request. This does not reserve a time or create a payment.",
    "provider_help": "Choose one provider, complete its setup, then verify its status before using it."
  },
  "workflow": {
    "customer": "Customer",
    "vehicle": "Vehicle",
    "stock_changed": "Stock has changed. Review the current balance before keeping your measured count.",
    "review_context": "Review current context and keep my edits",
    "review_context_help": "Review the current job identity, state and balance above. Continuing retains your entered service and billing details.",
    "estimate_unavailable": "Choose available services in one currency to see an estimate.",
    "no_services": "All matching services are already selected, or no service matches your search.",
    "add_service": "Add service",
    "choose_services": "Choose only the work to include. Additional services stay in this picker.",
    "add": "Add",
    "remove": "Remove",
    "line_discount": "Adjust line discount",
    "discount_none": "No discount",
    "discount_amount": "Fixed amount",
    "discount_percentage": "Percentage",
    "estimate": "Estimated total",
    "estimate_help": "Working estimate. Save and preview to review the exact taxes, rounding and terms before publishing.",
    "changed_service": "Catalogue terms changed. Review current terms before continuing; your entered price and quantity are retained.",
    "unavailable_service": "This service is no longer available. Remove it before continuing.",
    "review_service": "Accept current catalogue terms",
    "request_navigation": "Request sections",
    "conversation": "Conversation",
    "details": "Details",
    "activity": "Activity",
    "no_messages": "No imported messages are available.",
    "stock_return_help": "Record the actual receipt or physical count, then return to your unchanged measured usage.",
    "review_stock": "Review current stock and keep this count",
    "stock_products": "Products at this location",
    "stock_empty": "Out of stock",
    "stock_low": "Low stock",
    "search_products": "Search products",
    "document_details": "View document details",
    "document_help": "Issuance, delivery, reporting and receipt allocation are independent facts.",
    "decline_review": "Declining these terms does not cancel the work or move money. Confirm your decision below.",
    "offline_approval": "Record customer approval",
    "billing_history": "Review history",
    "current_terms": "Current terms"
  },
  "customer_deletions": {
    "title": "Delete customer",
    "start": "Start 30-day deletion",
    "queue": "Customer deletions",
    "restore": "Restore customer",
    "empty": "No customer deletions.",
    "explanation": "The customer and dependent operational data are hidden immediately. Administrators can restore this group before the 30-day deadline. After that, operational data is permanently removed.",
    "resolve": "First explicitly resolve active or future work, proposals and balances. Deletion does not cancel work or move money.",
    "confirm": "Type {{name}} to confirm",
    "basis": "Final applicable retention basis and additional requirements",
    "deadline": "Financial archive erasure date (UTC)",
    "policy": "Required when fiscal or payment evidence exists. Enter the final applicable deadline and factual/source basis after considering all relevant requirements. Erasure begins at 00:00 UTC on this exclusive date. Required evidence is encrypted separately; operational profiles, photos and full job history are removed.",
    "due": "Operational removal due",
    "states": {
      "pending": "Pending deletion",
      "restored": "Restored",
      "purged": "Operational data removed"
    },
    "archive": "View required financial evidence",
    "rule": "Retention date helper (optional)",
    "rules": {
      "custom": "Separately established applicable deadline",
      "ro_accounting": "Romania — accounting records",
      "us_ordinary": "US federal income tax — ordinary 3-year reference",
      "us_omission": "US federal income tax — over 25% omitted income, 6-year reference"
    },
    "rule_help": "Use actual business facts; the invoice issue date does not establish these deadlines. Choose the separate deadline path for other rules or exceptions.",
    "year_end": "Actual financial-year end date",
    "ro_help": "Accounting records: five years from 1 July following the financial-year end. The year may differ from the calendar year. Check any additional applicable requirements.",
    "ro_source": "Accounting Law, Articles 25 and 27",
    "filed": "Actual return filing date",
    "return_due": "Original statutory return due date (without filing extensions)",
    "exception": "US exception facts",
    "exceptions": {
      "unknown": "Not established",
      "none": "No special case or unresolved hold applies",
      "special": "Special case or hold — use a separate applicable deadline"
    },
    "us_help": "This is a federal period reference, not a safe UTC erasure date. Unfiled/fraudulent returns, property records, refund/carryback claims, bad debts and active audits/holds need separate treatment. State/local rules, full-day and timezone timing, weekends/holidays and assessment extensions may require a later date. No finite helper result is available for unknown or special cases.",
    "us_source": "IRS recordkeeping guidance",
    "us_timing_source": "IRS filing and deadline timing",
    "us_reference": "Federal reference anniversary: {{date}}. Enter the final applicable UTC erasure date and basis separately; the actual deadline may be later.",
    "ro_reference": "Accounting reference minimum: {{date}}. Enter the final applicable UTC erasure date and basis, including any additional requirements."
  },
  "workspace": {
    "navigation": "Job sections",
    "balance": "Outstanding balance",
    "review_billing": "Review billing",
    "action_help": "Confirm this action for the current Job revision.",
    "complete_help": "Completing work releases the bay. Payment and collection remain separate.",
    "back_parent": "Back to parent",
    "assign": "Assign team",
    "assignment_help": "Update operational responsibility. Accepted staff and billing responsibility remain recorded separately.",
    "assignment_pending": "Close or resolve the pending reschedule before changing the team.",
    "no_activity": "No recorded activity.",
    "assigned": "Team reassigned",
    "reordered": "Board position changed",
    "system": "System or customer action",
    "tabs": {
      "overview": "Overview",
      "schedule": "Schedule & team",
      "billing": "Billing",
      "payments": "Payments",
      "documents": "Documents",
      "products": "Products",
      "activity": "Activity"
    },
    "events": {
      "created": "Created",
      "updated": "Updated",
      "job_board_ordered": "Board position changed"
    },
    "kinds": {
      "Job": "Job",
      "BillingReview": "Billing review",
      "JobReschedule": "Reschedule",
      "PaymentPosting": "Payment entry",
      "AdvanceRequest": "Advance request",
      "FiscalDocument": "Fiscal document",
      "ProductConsumption": "Product use"
    }
  },
  "home_attention": {
    "today": "Today's work",
    "view_schedule": "View schedule",
    "today_empty": "No scheduled or ongoing Jobs for today.",
    "today_more": "Showing the first 8 of {{count}} Jobs. Open the schedule for the remaining work.",
    "title": "Needs attention",
    "help": "Current work at this location. Open a queue to review its records.",
    "requests": "New requests",
    "overdue": "Overdue advances",
    "stock": "Products at or below threshold",
    "setup": "Prepare this location",
    "setup_help": "Add the prerequisites needed for booking. These links open the current location settings.",
    "ask_admin": "Ask an administrator to add an enabled bay and an available service offering before booking.",
    "add_bay": "Add an enabled bay",
    "add_service": "Add an available local service",
    "filtered": "Stage: {{stage}}"
  },
  "board_interactions": {
    "destination_position": "Position {{position}} in {{stage}}.",
    "start": "Start of stage",
    "end": "End of stage",
    "drag": "Drag Job for {{name}}",
    "move": "Move Job",
    "help": "Drag a card to move it, or tap its background for placement options. Done requires completed work, payment and collection.",
    "instructions": "Press Space or Enter to pick up a Job. Use Up and Down to reorder, and Left and Right to choose an eligible stage. Press Space or Enter to drop, or Escape to cancel. Tab also ends the drag. Press Shift+F10 for placement options without dragging.",
    "picked": "Picked up Job for {{name}}.",
    "destination": "Destination: {{stage}}.",
    "no_target": "No eligible destination.",
    "dropped": "Drop selected. Required choices must be confirmed before saving.",
    "cancelled": "Move cancelled. Original position retained.",
    "saved": "Job movement saved.",
    "restored": "Move not saved. Current server order restored.",
    "page": "Page {{page}} of {{pages}}",
    "menu_help": "Choose a stage and position relative to a Job on its displayed page. Other column pages retain their place.",
    "stage": "Destination stage",
    "position": "Position",
    "before": "Before",
    "after": "After",
    "neighbor": "Neighboring Job",
    "confirm": "Move to {{stage}}",
    "confirm_help": "The Job stays in its current position until you confirm. Cancel leaves it unchanged.",
    "save_move": "Confirm move",
    "continue": "Continue",
    "card": "Job card"
  },
  "calendar_views": {
    "period": {
      "past": "Past scheduled interval",
      "current": "Current scheduled interval",
      "future": "Future scheduled interval"
    },
    "show_day": "Show day",
    "show_week": "Show week",
    "show_agenda": "Show agenda",
    "notes": "Scheduling details and keyboard controls",
    "slot": "Create booking: {{bay}}, {{date}}, {{time}}. Availability checked on save.",
    "slot_keys": "In an empty time cell, use Up/Down or Home/End to select an hour, then Enter to create a booking.",
    "views": "Schedule views",
    "day": "Day",
    "week": "Week",
    "agenda": "Agenda",
    "day_date": "Date",
    "partial": "This is one page of a busy schedule. Other pages may contain more reservations; an empty area does not establish availability.",
    "capacity_help": "Times use the location time zone. Ongoing bay occupancy can extend beyond the planned end. Booking availability is checked when you save.",
    "timeline": "Bay timeline",
    "bay_timeline": "Weekly timeline for {{bay}}",
    "create_slot": "Create booking",
    "no_entries": "No entries on this page for this day."
  },
  "staff_ux": {
    "estimate_help": "Estimated from the selected services. Final taxes and rounding are calculated when you confirm the job.",
    "booking_steps": "Booking steps",
    "step_count": "Step {{current}} of {{total}}",
    "back": "Back",
    "continue": "Continue",
    "review_help": "Confirm these details to create the job. Availability and current service terms are checked again when you save.",
    "steps": {
      "customer": "Customer",
      "vehicle": "Vehicle",
      "services": "Services",
      "schedule": "Schedule & team",
      "review": "Review"
    },
    "step_titles": {
      "customer": "Choose a customer",
      "vehicle": "Choose a vehicle",
      "services": "Choose services",
      "schedule": "Schedule & team",
      "review": "Review booking"
    },
    "location_details_help": "Name and address for this physical location.",
    "location_regional_help": "Language, currency and time zone for work at this location.",
    "location_booking_help": "Set how long a proposed time remains reserved for a customer."
  },
  "navigation": {
    "new_job": "New job",
    "dashboard": "Dashboard",
    "calendar": "Calendar",
    "job_board": "Job board",
    "location_settings": "Location settings",
    "regional": "Regional preferences",
    "opening_hours": "Opening hours",
    "booking_rules": "Booking rules",
    "switch_location": "Switch location",
    "user_menu": "User menu",
    "home": "Home",
    "schedule": "Schedule",
    "subscription": "Subscription",
    "board": "Board",
    "list": "List",
    "daily": "Daily work",
    "jobs_views": "Jobs views",
    "location_details": "Location details",
    "settings_sections": "Settings sections",
    "danger": "Danger zone",
    "close": "Close navigation",
    "skip": "Skip to main content",
    "back_to_collection": "Back to results",
    "recovery": "Access recovery",
    "groups": {
      "personal": "Personal",
      "company": "Company",
      "location": "Location",
      "history": "History"
    }
  },
  "whatsapp": {
    "enquiry": "WhatsApp enquiry",
    "description": "Connect an eligible company-owned WhatsApp Business account and registered Cloud API number through Meta Embedded Signup.",
    "constraints": "Meta app access, business verification and number registration are required. Customer initiation opens a 24-hour service window, not business-initiated consent. Business-initiated messages require consent and approved templates. No outbound sender or template approval is available here.",
    "guide": "Meta Embedded Signup setup guide",
    "unavailable": "WhatsApp authorization or readiness is unavailable. Check the Meta app, permissions, business ownership and registered Cloud API number. Human/provider approval may still be required.",
    "default_location": "Default intake location",
    "authorize": "Start WhatsApp authorization",
    "continue": "Continue with Meta",
    "company_owned": "I confirm this business account and number belong to this company and I am authorized to connect them.",
    "choose_number": "Choose an authorized number",
    "intake_at": "New enquiries arrive at {{location}}.",
    "no_numbers": "No eligible registered Cloud API number was returned. Complete Meta business/number verification and registration, then authorize again.",
    "number": "Business number",
    "connect": "Connect selected number",
    "disconnect": "Disconnect WhatsApp",
    "save_location": "Save intake location",
    "checked": "Last verified: {{date}}",
    "environment": {
      "test": "WhatsApp test connections",
      "live": "WhatsApp live connections"
    },
    "states": {
      "ready": "Connected and last verified",
      "pending": "Subscription verification pending",
      "disconnected": "Disconnected",
      "unavailable": "Authorization needs attention. Authorize the number again."
    },
    "messages": "WhatsApp messages",
    "attachments": "{{count}} attachment(s) received. Open the WhatsApp inbox to review the original media.",
    "window": "Customer service window ends at {{time}}. This timestamp grants neither consent nor sending permission.",
    "outbound_unavailable": "Sending is unavailable. Business-initiated messaging requires consent and an approved template; template readiness has not been verified. Record an externally handled response using the existing response action.",
    "connected": "WhatsApp number connected and last verified.",
    "location_saved": "Default intake location saved. Existing enquiries keep their current location.",
    "disconnected": "WhatsApp disconnected. Existing enquiry history remains."
  },
  "instagram": {
    "enquiry": "Instagram enquiry",
    "description": "Connect a Business or Creator account through Instagram Login and choose where new enquiries arrive. A Facebook Page is not required.",
    "constraints": "Customer initiation and Meta messaging permissions are required. Tokens expire or can be revoked. Ordinary replies have a 24-hour window. Production access and any extended messaging require separate Meta approval.",
    "guide": "Meta Instagram Login setup guide",
    "unavailable": "Instagram setup is unavailable. Ask your platform administrator to complete the app and callback configuration.",
    "default_location": "Default intake location",
    "authorize": "Authorize Instagram account",
    "choose_account": "Choose an authorized account",
    "intake_at": "New enquiries arrive at {{location}}.",
    "no_accounts": "No eligible professional account was returned. Check account type and the requested Instagram permissions, then authorize again.",
    "account": "Instagram account",
    "connect": "Connect selected account",
    "disconnect": "Disconnect account",
    "save_location": "Save intake location",
    "checked": "Last verified: {{date}}",
    "environment": {
      "test": "Instagram test connections",
      "live": "Instagram live connections"
    },
    "states": {
      "ready": "Connected and last verified",
      "pending": "Subscription verification pending",
      "disconnected": "Disconnected",
      "unavailable": "Authorization needs attention. Authorize the account again."
    },
    "messages": "Instagram messages",
    "attachments": "{{count}} attachment(s) received. Open the Instagram inbox to review the original media.",
    "window": "Ordinary messaging window ends at {{time}}. This timestamp does not authorize a send.",
    "outbound_unavailable": "Sending through GarageClerk is unavailable until supported operational messaging is enabled. Record any reply made in your Instagram inbox using the existing response action.",
    "connected": "Instagram account connected and verified.",
    "location_saved": "Default intake location saved. Existing enquiries keep their current location.",
    "disconnected": "Instagram account disconnected. Existing enquiry history remains."
  },
  "facebook": {
    "description": "Connect Pages your company manages and choose where new enquiries arrive.",
    "constraints": "Meta permissions, app review and Page authorization are required. Tokens can expire or be revoked. Ordinary replies are subject to a 24-hour window; other message types require separate provider approval.",
    "guide": "Meta Messenger setup guide",
    "unavailable": "Facebook setup is unavailable. Ask your platform administrator to complete the app and callback configuration.",
    "default_location": "Default intake location",
    "authorize": "Authorize Facebook Pages",
    "choose_page": "Choose an authorized Page",
    "intake_at": "New enquiries arrive at {{location}}.",
    "no_pages": "No eligible Pages were returned. Check Page tasks and the requested permissions in Meta, then authorize again.",
    "page": "Facebook Page",
    "connect": "Connect selected Page",
    "disconnect": "Disconnect Page",
    "save_location": "Save intake location",
    "checked": "Last verified: {{date}}",
    "environment": {
      "test": "Messenger test connections",
      "live": "Messenger live connections"
    },
    "states": {
      "ready": "Connected and last verified",
      "pending": "Subscription verification pending",
      "disconnected": "Disconnected",
      "unavailable": "Authorization needs attention. Authorize the Page again."
    },
    "messages": "Messenger messages",
    "attachments": "{{count}} attachment(s) received. Open the Page inbox to review the original media.",
    "window": "Ordinary messaging window ends at {{time}}. This timestamp does not authorize a send.",
    "outbound_unavailable": "Sending through GarageClerk is unavailable until supported operational messaging is enabled. Record any reply made in your Page inbox using the existing response action.",
    "connected": "Facebook Page connected and verified.",
    "location_saved": "Default intake location saved. Existing enquiries keep their current location.",
    "disconnected": "Facebook Page disconnected. Existing enquiry history remains."
  },
  "fiscal_documents": {
    "refresh": "Refresh from confirmed review",
    "refresh_confirm": "Replace this unissued draft’s charges with the current confirmed review and clear its conversion evidence.",
    "review_changed": "The final review changed. Refresh this draft and review its fiscal details before issuance.",
    "credited_minor": "Issued credit documents",
    "credit_balance_minor": "Received funds above the fiscal balance",
    "allocation_history": "Recent receipt allocations",
    "connection_pending": "Provider connection pending",
    "title": "Fiscal documents",
    "prepare": "Prepare fiscal draft",
    "save": "Save fiscal draft",
    "edit": "Edit billing details",
    "draft_help": "Save billing details for the confirmed final review. A draft has no fiscal number and has not been issued or sent.",
    "provider_context": "Chosen provider context",
    "context_help": "Use the merchant’s actual provider account and explicit document/reporting settings references. No series, number, tax rule or provider fallback is selected automatically.",
    "independent_help": "Issuance, customer delivery, fiscal reporting, payment allocation and vehicle collection are separate facts.",
    "review_required": "Confirm the final billing review with an eligible billing assignee before preparing an invoice.",
    "empty": "No fiscal documents.",
    "unavailable": "A verified provider connection is required before issuance. Draft preparation does not connect a provider or perform fiscal reporting.",
    "confirm": "I reviewed the fiscal details and chosen provider context.",
    "request": "Request issuance or reconciliation",
    "provider": "Invoice provider",
    "provider_account": "Merchant provider account",
    "environment": "Environment",
    "document_context": "Document settings reference",
    "reporting_context": "Reporting settings reference",
    "stripe": "Stripe",
    "smartbill": "SmartBill",
    "easybill_ro": "EasyBill.ro",
    "test": "Test",
    "live": "Live",
    "issuer": "Legal issuer",
    "customer": "Invoice customer",
    "fiscal": "Additional fiscal evidence",
    "tax_help": "Explicit service taxes and discounts come from the confirmed review. Supply conversion/reporting evidence only when required by the verified context. US tax settings remain merchant-managed; automatic tax determination is deferred.",
    "name": "Legal name",
    "country": "Country",
    "address": "Billing address",
    "city": "City",
    "region": "County / state",
    "postal_code": "Postal code",
    "tax_identifier": "Fiscal identifier",
    "email": "Billing email",
    "vat_ron": "VAT amount (RON)",
    "vat_ron_minor": "VAT amount (RON)",
    "fx_reference": "Conversion evidence reference",
    "tax_setup_reference": "Merchant tax settings reference",
    "invoice": "Invoice",
    "credit_note": "Full credit note",
    "draft": "Draft — not issued",
    "requested": "Issuance requested",
    "uncertain": "Outcome uncertain — reconciliation required",
    "rejected": "Provider confirmed no issuance",
    "issued": "Issued",
    "net_minor": "Net",
    "tax_minor": "Tax",
    "item_discount_minor": "Service discounts",
    "job_discount_minor": "Job discount",
    "total_minor": "Gross total",
    "advance_minor": "Advances preserved at issuance",
    "amount_due_minor": "Due after represented advances",
    "allocated_minor": "Currently allocated net funds",
    "outstanding_minor": "Unallocated document balance",
    "delivery": "Customer delivery",
    "reporting": "Fiscal reporting",
    "not_requested": "Not requested",
    "not_required": "Not required in chosen context",
    "pending": "Pending",
    "delivered": "Delivered",
    "failed": "Failed",
    "accepted": "Accepted",
    "rejected_status": "Rejected",
    "inclusive": "Tax included",
    "exclusive": "Tax added",
    "allocate": "Allocate existing receipt",
    "allocation_help": "Applies already recorded money to this document. This does not receive funds or change the job balance.",
    "receipt": "Recorded receipt"
  },
  "resources": {
    "title": "Active resources and handoffs",
    "description": "Choose the staff and locations to retain. Deactivation is immediate and preserves authorized history.",
    "paused": "Operations are paused until resources fit the current plan.",
    "resolve_or_upgrade": "Keep locations with unresolved commitments. Resolve their open work before deactivation. If the current plan cannot retain them, upgrade in Billing to resume that work.",
    "plan": "Apply these resource limits",
    "limits": "{{staff}} staff · {{locations}} locations",
    "unlimited": "Unlimited",
    "no_subscription_change": "This saves resource choices immediately. It does not change your subscription or charge money.",
    "staff": "Retained staff",
    "staff_help": "Keep yourself as administrator. Uncheck staff only after explicitly choosing eligible replacements for their unfinished operational and billing work.",
    "locations": "Retained locations",
    "locations_help": "Open enquiries, proposals, bookings, work and customer balances must be resolved before a location can be deactivated. Commitments are never moved or cancelled here.",
    "unresolved": "Unresolved commitments",
    "handoffs": "Unfinished work handoffs",
    "handoffs_help": "For each affected Job, choose its complete current operational team and a billing replacement when one is assigned. Retain those staff. Pending reschedule offers must be resolved first. Accepted prices, schedule and original authorship stay preserved.",
    "review_notice": "After a handoff, prepare pending billing reviews again from the current Job. Confirmed amounts and customer approval history remain preserved.",
    "current_assignment": "Current assignee: {{name}}",
    "operational_replacement": "Operational replacement",
    "billing_replacement": "Billing replacement (administrator or manager)",
    "choose": "Choose explicitly",
    "helpers": "Retained helpers (optional)",
    "save": "Save retained resources and handoffs",
    "retained_history": "Retained location history",
    "history_help": "Read-only represented visits and actual balances remain available to authorized active staff. Customer history keeps its original access rules.",
    "inactive": "Inactive",
    "reactivate": "Reactivate {{name}}",
    "no_jobs": "No recorded Jobs at this location.",
    "balance": "Total: {{total}} · Received: {{received}} · Outstanding: {{outstanding}}"
  },
  "vehicle_reports": {
    "title": "Vehicle service history",
    "scope": "Accepted Job terms at the represented schedule, in chronological order. Prices, when shown, are the accepted amounts including tax after discounts. Later billing changes are separate. This service report is not an invoice.",
    "customer": "Recorded customer / owner",
    "date": "Represented visit",
    "currency": "Agreed currency",
    "reference": "Job reference",
    "services": "Represented services",
    "line_total": "Accepted line total",
    "item_discount_minor": "Service discounts",
    "job_discount_minor": "Job discount",
    "net_minor": "Net amount",
    "tax_minor": "Tax",
    "total_minor": "Accepted Job total",
    "prices_excluded": "Service prices excluded",
    "photo_scope": "Vehicle photo preserved in this branch for this Job's vehicle revision and recorded customer.",
    "include_prices": "Include accepted service prices",
    "include_photos": "Include historical vehicle photos",
    "select": "Select visit",
    "download": "Download PDF",
    "empty": "No authorized Jobs for this vehicle at this location.",
    "limits": "Select 1–20 visits from this page. Reports support up to 200 services, 12 photos, 80 pages and 10 MB. Large histories can be exported in smaller selections.",
    "open": "Vehicle service history"
  },
  "payments": {
    "overdue_summary": "{{count}} Job(s) have an overdue advance, including bookings outside this board’s schedule.",
    "review_overdue": "Review overdue advances",
    "all_jobs": "Show all Jobs",
    "title": "Payments and advances",
    "record": "Record external money",
    "request": "Request an advance",
    "external_help": "Record only money actually received, refunded or corrected outside GarageClerk. This does not collect money, issue invoices or change subscription billing. Each new entry records a separate movement; retry the same entry only for the same movement.",
    "request_help": "An advance request asks for an additional amount toward the current confirmed total. It records no funds. Subsequent receipts settle the oldest requests first, including receipts entered without a request link. Each minor unit counts once. Overdue requests alert staff without cancelling the booking.",
    "selected_request": "Advance request",
    "kind": "Entry type",
    "amount": "Amount",
    "amount_help": "Use at most two decimal places. Enter refunds as positive amounts; only adjustments may be negative. Refunds and negative adjustments require an administrator or manager.",
    "method": "External method",
    "reference": "Receipt or transfer reference",
    "occurred_at": "Actually occurred at",
    "recorded_at": "Recorded at",
    "reason": "Audit reason",
    "time_help": "Use ISO date/time with an explicit UTC offset, for example 2026-11-02T10:00:00+02:00. Display location: {{zone}}. Preserve the actual time, including historical receipts.",
    "request_kind": "Advance basis",
    "fixed": "Fixed amount",
    "percentage": "Percentage of confirmed total",
    "value": "Amount or percentage",
    "due_at": "Due at",
    "total": "Confirmed service total",
    "received": "Net received",
    "outstanding": "Outstanding job balance",
    "credit": "Excess received",
    "requests": "Advance requests",
    "entries": "Money history",
    "no_requests": "No advance requests.",
    "empty": "No external money recorded.",
    "overdue": "Advance overdue. Follow up with the customer; the booking remains confirmed.",
    "requested": "Requested amount",
    "request_remaining": "Advance still due",
    "receive_advance": "Record received advance",
    "allocated": "Linked to an advance request for audit; receipts settle oldest requests first.",
    "kinds": {
      "payment": "Payment received",
      "advance": "Advance received",
      "refund": "External refund",
      "adjustment": "External correction",
      "reconciliation": "External balance reconciliation"
    },
    "methods": {
      "cash": "Cash",
      "bank_transfer": "Bank transfer",
      "card": "External card payment",
      "other": "Other"
    }
  },
  "product_consumptions": {
    "quantity": "Actual quantity used",
    "title": "Actual product consumption",
    "record": "Record actual use",
    "product": "Product",
    "help": "Optional actual usage only. Job progress and service estimates never deduct stock. Each new entry records additional actual usage.",
    "no_products": "Add a product in Inventory before recording actual usage.",
    "correction_help": "Insufficient stock? Record only an actual receipt or physical count in a separate tab, then return here and retry.",
    "empty": "No actual product consumption recorded."
  },
  "billing_reviews": {
    "current_total": "Reviewed service total: {{amount}}",
    "title": "Billing review",
    "prepare": "Prepare billing",
    "prepare_help": "Keep accepted services or remove them, adjust prices and discounts, or add an available service. Save a private preview before sharing or confirming.",
    "include": "Include this service",
    "line_discount": "Line discount (amount)",
    "line_percentage": "Line discount (%)",
    "job_discount": "Job discount (amount)",
    "job_percentage": "Job discount (%)",
    "advance": "Received advance deduction",
    "advance_help": "Received money reduces the amount due. It does not reduce the service total or tax.",
    "due": "Amount due after advance",
    "received": "Recorded received money: {{amount}}",
    "billing_details": "Invoice billing details",
    "details_help": "These details are separate from the customer profile. The selected invoice provider may require additional information before issuance.",
    "name": "Billing name",
    "country": "Billing country",
    "address": "Billing address",
    "tax_identifier": "Tax identifier",
    "preview": "Save and preview",
    "increase": "This total is above the originally accepted terms. Obtain renewed customer approval for this exact review before final confirmation.",
    "confirm_terms": "I have reviewed these exact services, amounts and billing details.",
    "publish": "Confirm and share review",
    "published": "The review is available to the customer through its link. Preview and confirm an email separately to send it.",
    "offline": "Record customer approval",
    "method": "Approval method",
    "phone": "Phone",
    "in_person": "In person",
    "who": "Who approved",
    "at": "Approval time (include UTC offset)",
    "what": "What the customer approved",
    "record_approval": "Record explicit approval",
    "approval_saved": "Customer approval recorded",
    "confirm": "Confirm final review",
    "confirmed_notice": "Final review confirmed. An invoice has not been issued or sent.",
    "stale": "The job or terms changed. Prepare a new review from the current job.",
    "link": "Customer review link",
    "open": "Open billing review",
    "approve": "Approve these exact terms",
    "reassign": "Reassign billing responsibility",
    "verified_customer": "Verified customer",
    "link_access": "Customer link",
    "staff": "Staff",
    "states": {
      "draft": "Private preview",
      "proposed": "Shared for review",
      "approved": "Customer approved",
      "declined": "Customer declined",
      "confirmed": "Final review confirmed"
    }
  },
  "job_board": {
    "physical_bay": "Physical bay",
    "capacity_started_at": "Physical arrival recorded",
    "capacity_released_at": "Bay released at",
    "capacity_states": {
      "hold": "Bay held",
      "confirmed": "Bay reserved",
      "in_progress": "Bay occupied",
      "released": "Bay released",
      "expired": "Bay hold expired"
    },
    "title": "Job board",
    "history": "Search job history",
    "range": "To do: overdue work and {{from}}–{{through}} · {{zone}}",
    "done_help": "Done stays here for five days after payment and collection, then remains in job history.",
    "empty": "No jobs in this stage.",
    "pages": "{{stage}} pages",
    "balance": "Outstanding: {{amount}}",
    "received": "Received: {{amount}}",
    "collected": "Collected",
    "send_arrival": "Send arrival notice?",
    "send_yes": "Send notice",
    "send_no": "Continue without notice",
    "start": "Start work",
    "complete": "Mark ready for collection",
    "billing": "Billing handoff",
    "billing_help": "Choose the administrator or manager responsible for billing. Work completes and the bay is released when you enter Billing.",
    "billing_assignee": "Billing assignee",
    "no_billing_staff": "An administrator must enable an eligible billing assignee at this location.",
    "bill": "Move to Billing",
    "collection_help": "Record physical collection independently of payment. Done requires both collection and full payment.",
    "collect": "Record collection",
    "cancel_title": "Cancellation or no-show",
    "cancel_help": "Record the reason and release the reservation. Payment history is retained; this action issues no refund.",
    "cancel_type": "Outcome",
    "reason": "Reason",
    "cancel": "Record outcome",
    "events": "View immutable activity history",
    "search": "Search customer, vehicle or registration",
    "search_button": "Search",
    "arrived_at": "Garage arrival",
    "completed_at": "Work completed",
    "collected_at": "Vehicle collected",
    "done_at": "Entered Done",
    "cancelled_at": "Outcome recorded",
    "stages": {
      "to_do": "To do",
      "in_progress": "In progress",
      "ready_for_collection": "Ready for collection",
      "billing": "Billing",
      "done": "Done",
      "cancelled": "Cancelled",
      "no_show": "No-show"
    }
  },
  "notifications": {
    "action_required": "An email needs staff attention. Open email history to review the failure or uncertain delivery.",
    "preview": "Preview email",
    "history": "Email history",
    "recipient": "Recipient",
    "no_email": "No email saved",
    "confirm": "Confirm and queue email",
    "retry": "Retry delivery",
    "attempts": "Delivery attempts",
    "empty": "No email has been queued.",
    "queued": "Email queued. Check its history for delivery status.",
    "stale": "The content or recipient changed. Review the current preview before confirming.",
    "verified_email_required": "Ask the customer to verify the saved email before sending. Verification messages are still allowed.",
    "superseded": "This message is outdated. Preview the current proposal or appointment instead.",
    "undeliverable": "The provider reported this email undeliverable. Contact the customer and correct or verify their email before sending a new communication.",
    "provider_failure": "The mail provider could not confirm acceptance. Check configuration and retry the same message.",
    "reconciliation_required": "Delivery is uncertain. Check the provider's delivery record before contacting the customer; automatic retry is blocked to prevent duplicates.",
    "sent_help": "Sent means the configured mail provider accepted the email. It does not confirm customer receipt. Failed or uncertain messages need staff attention.",
    "states": {
      "queued": "Queued",
      "sending": "Sending — acceptance not yet confirmed",
      "sent": "Sent to mail provider",
      "failed": "Failed — staff action needed",
      "retried": "Retried"
    }
  },
  "website_requests": {
    "contact": "Your contact details",
    "customer": "Your saved company profile",
    "new_details": "Enter new details",
    "vehicle": "Your vehicle",
    "new_vehicle": "Enter another vehicle",
    "name": "Name",
    "email": "Email",
    "phone": "Phone (optional, international prefix)",
    "privacy": "Verify your email before this request is submitted. Saved profiles are available only after authorized sign-in. Existing contacts are never merged or overwritten.",
    "photos": "Photos (optional)",
    "photos_help": "Up to 8 JPEG, PNG, WebP or GIF photos, 10 MB each. Photos stay private.",
    "service": "Services and desired time",
    "describe_service": "Describe the service below",
    "service_details": "Requested services",
    "body": "Your message",
    "desired_start": "Desired start",
    "desired_end": "Desired end",
    "interval_help": "Enter dates and times in the location time zone: {{zone}}. This is a preference; the garage checks availability and sends a proposal. No bay is reserved.",
    "start_offset": "Start UTC offset",
    "end_offset": "End UTC offset",
    "choose_offset": "Choose the occurrence",
    "submit": "Save and verify email",
    "resend": "Save changes and resend verification",
    "verification_sent": "Your private draft is saved. Check your email and confirm the link to submit it. You can correct the details and resend.",
    "submitted": "Your request has been submitted. The garage will review your details and availability. Creating a password is optional for submission and required to access your history.",
    "another": "Make another enquiry",
    "delivery_failed": "Your private draft is saved, but the verification email could not be sent. Try again.",
    "retry": "Your draft needs review before submission. Return to the enquiry, correct the details and request a new verification email.",
    "pending": "These are the submitted details. Complete the customer identity using the existing contact matching decision before sending a proposal.",
    "snapshot": "Submitted website details",
    "continue": "Continue securely to your enquiry"
  },
  "domains": {
    "auth_unavailable": "Customer sign-in is awaiting the canonical HTTPS application host. Contact GarageClerk to finish hosting setup.",
    "title": "Custom domain",
    "help": "Use one CNAME hostname, such as booking.your-company.com. Enter a hostname only, without a protocol, path or port. Your company website must also be published.",
    "hostname": "Website hostname",
    "save": "Save domain",
    "verify": "Check ownership and readiness",
    "remove": "Remove domain",
    "plan_required": "Custom domains require an active Plus or Pro plan, or the Plus-feature trial. Your saved hostname is retained while this feature is unavailable.",
    "saved": "Domain saved. Add the DNS records, then check ownership and readiness.",
    "removed": "Domain removed.",
    "checked": "Domain check completed. Review the current status below.",
    "conflict": "This hostname is already configured. Choose another hostname or contact support to resolve ownership.",
    "txt_name": "TXT record name",
    "txt_value": "TXT record value",
    "cname": "CNAME destination for your hostname",
    "target_missing": "Hosting destination is not configured. Contact GarageClerk with the intended hostname; the operator must supply the approved CNAME destination and enable hostname routing and TLS.",
    "tls_help": "DNS propagation can take time. Keep the TXT record in place. A certificate must be issued by the approved host; saving a hostname does not issue one. Checks refresh automatically after 12 hours when the production job worker is running. Routing stops if proof is older than 24 hours, the certificate expires, or plan access ends.",
    "refresh_required": "Routing is unavailable. Recheck DNS, certificate and hosting configuration.",
    "checked_at": "Last check: {{date}}",
    "ownership_at": "Ownership checked: {{date}}",
    "certificate_at": "Certificate expires: {{date}}",
    "states": {
      "pending": "Pending: publish the TXT record, then check ownership.",
      "ownership_required": "Ownership not verified: publish the exact TXT record below and retry.",
      "hosting_required": "Ownership verified; the operator must configure the approved hosting destination before DNS and TLS can be checked.",
      "dns_required": "Ownership verified; the hostname must have a CNAME matching the destination below.",
      "tls_required": "Ownership and CNAME verified; a valid public HTTPS certificate for this hostname is still required. Ask the hosting operator to issue or renew it.",
      "failed": "The DNS or TLS check failed. Check DNS propagation, the public hosting destination and certificate, then retry.",
      "ready": "Ownership, CNAME and public HTTPS certificate checked. The published company website can use this hostname while those checks and plan access remain valid."
    }
  },
  "website": {
    "title": "Company website",
    "saved": "Website settings saved.",
    "public_help": "Only published content is visible to visitors. Publish locations and select the services you want to share. Text is displayed as plain text.",
    "brand_name": "Public company name",
    "headline_en": "English headline",
    "headline_ro": "Romanian headline",
    "description_en": "English introduction",
    "description_ro": "Romanian introduction",
    "publish_site": "Publish company website",
    "publish_location": "Publish this location",
    "location_description": "Public location description",
    "public_services": "Public services",
    "services_help": "Only selected, available services in the location currency appear publicly. Archived services are hidden.",
    "save": "Save website",
    "save_location": "Save location page",
    "view": "View public website",
    "choose_location": "Choose a location",
    "all_locations": "All locations",
    "services": "Services",
    "empty_services": "No services are published for this location.",
    "enquire": "Enquire at this location",
    "enquire_service": "Enquire about this service",
    "entry_title": "Your enquiry location",
    "entry_help": "Complete your details, then verify your email to submit your request. The garage will check availability.",
    "sign_in": "Customer sign in",
    "signed_in": "You are signed in. Choose your authorized saved profile or enter new details.",
    "history": "View your customer history",
    "back": "Back to location",
    "minutes": "{{count}} minutes",
    "inclusive": "Tax included",
    "exclusive": "Tax added",
    "locations": "Locations",
    "language": "Page language: {{language}}",
    "en": "English",
    "ro": "Romanian",
    "unpublished": "Save and publish the website to make it public.",
    "no_locations": "No locations are currently published."
  },
  "proposals": {
    "legacy_help": "This earlier proposal has no bay hold. Ask the garage to review, assign and republish it before you can respond. Its original services, prices and schedule remain available.",
    "expired": "The hold expired at {{expiry}}; the bay is no longer held.",
    "suggestion_help": "Your suggestion reserves no alternative. The original bay remains held only until its disclosed expiry; staff will check availability. You can still accept the original proposal.",
    "accept": "Accept and confirm booking",
    "publish_hold": "Publishing will hold this bay for {{hours}} hours and disclose the expiry to the customer.",
    "read_only": "This proposal is read-only while the garage’s operational access is unavailable. Contact the garage to continue.",
    "suggestion_status": "Alternative requested: {{time}}. Staff must check availability; no alternative is reserved.",
    "declined_status": "Proposal declined. Its hold has been released.",
    "accepted_status": "Booking confirmed for the services, prices and schedule above.",
    "accept_help": "Accepting confirms the services, prices and original schedule displayed above.",
    "decline_note": "Reason (optional)",
    "alternative": "Your preferred alternative time",
    "suggest": "Suggest another time",
    "decline": "Decline proposal",
    "decision": "Your decision",
    "expiry_help": "After the deadline, acceptance checks availability again. The garage may need to offer another time.",
    "held_until": "This bay is held until {{expiry}}.",
    "hold": "Proposal hold",
    "history": "Published revisions (latest 30)",
    "title": "Service proposal",
    "compose": "Compose proposal",
    "preview": "Customer preview",
    "edit": "Edit private draft",
    "publish": "Publish proposal",
    "save_preview": "Save and preview",
    "private_help": "Private draft. Customers see the latest published version only.",
    "capacity_help": "Publishing temporarily holds this bay until the disclosed expiry. Acceptance confirms the booking after an availability check.",
    "view_help": "Review the displayed services, prices and schedule before deciding.",
    "link": "Authorized viewing link",
    "delivery_help": "Anyone with this link can view and respond to this proposal. Copy it only to the intended customer through your agreed channel. Publishing does not send a message.",
    "open": "Open customer view",
    "recompose": "The enquiry’s customer, vehicle or location changed. Recompose and review the draft before publishing.",
    "quantity": "Quantity",
    "unit_price": "Unit price",
    "discount_amount": "Line discount (currency amount)",
    "discount_percentage": "Line discount (%)",
    "discount": "Discount",
    "overall_discount": "Overall discount (proposal currency)",
    "net": "Net amount",
    "tax": "Tax",
    "total": "Total",
    "inclusive": "Tax included",
    "exclusive": "Tax added"
  },
  "requests": {
    "customer_associated": "Customer reused. Choose the vehicle to finish the enquiry.",
    "use_customer": "Use customer and choose vehicle",
    "choose_vehicle": "Vehicle for this enquiry",
    "new_vehicle": "Enter a new vehicle",
    "search_vehicles": "Search saved vehicles",
    "vehicle_help": "Choose this customer’s saved vehicle or enter another. Other locations’ work and photos stay private.",
    "intake_location": "Original intake location",
    "title": "Requests",
    "add": "Add enquiry",
    "save": "Save enquiry",
    "saved": "Enquiry saved.",
    "routed": "Enquiry routed.",
    "stale": "This enquiry changed. Review the current details and try again.",
    "search": "Search enquiries",
    "state": "State",
    "all": "All states",
    "filter": "Filter",
    "empty": "No enquiries here yet.",
    "unnamed": "Unnamed enquiry",
    "pages": "Enquiry pages",
    "previous": "Previous",
    "next": "Next",
    "page": "Page {{page}} of {{pages}}",
    "channel": "Source channel",
    "channel_identity": "Channel identity",
    "body": "Enquiry message",
    "service_details": "Requested services",
    "details": "Enquiry details",
    "complete": "Details complete",
    "incomplete": "More details needed",
    "services_missing": "Requested services have not been collected.",
    "intake_help": "Record an enquiry at this location. Missing customer or vehicle details can be collected later. This form does not connect or send messages to a provider.",
    "identity_help": "For social enquiries, supply the source conversation or sender identifier. It does not verify a customer.",
    "complete_details": "Complete details",
    "completion_help": "A customer name, email or international phone number, vehicle make/model and requested services are required before a proposal or confirmed job.",
    "save_details": "Save details",
    "correct_contacts": "Create new / correct entered contacts",
    "saved_customer_help": "Reuse uses the chosen customer’s saved details. Entered contacts are only checked for an exact match; they do not overwrite the saved customer.",
    "view_job": "View confirmed job",
    "record_response": "Record a response",
    "response_help": "Record a reply or customer decision already communicated outside GarageClerk. No message is sent by this action.",
    "action": "Response type",
    "note": "Response or decision details",
    "suggested_time": "Customer’s suggested time",
    "suggestion_help": "This is a suggestion only. It does not reserve a bay or reschedule a confirmed job.",
    "record": "Record response",
    "route": "Route enquiry",
    "routing_help": "Move this unquoted enquiry to another permitted location. The original intake and enquiry history are retained.",
    "history": "Enquiry history",
    "system": "System",
    "updated": "Updated",
    "states": {
      "new": "New",
      "responded": "Responded",
      "accepted": "Accepted",
      "declined": "Declined",
      "rescheduled": "Rescheduled"
    },
    "actions": {
      "responded": "Reply already made",
      "declined": "Decline already communicated",
      "rescheduled": "Alternative time suggested"
    },
    "history_actions": {
      "whatsapp_intake": "WhatsApp enquiry received",
      "whatsapp_message": "WhatsApp message received",
      "instagram_intake": "Instagram enquiry received",
      "website_intake": "Website request submitted",
      "customer_associated": "Customer reused",
      "intake": "Enquiry received",
      "complete": "Details completed",
      "responded": "Response recorded",
      "declined": "Decline recorded",
      "rescheduled": "Alternative time suggested",
      "routed": "Enquiry routed",
      "staff_booking": "Accepted through staff booking"
    },
    "channels": {
      "website": "Website",
      "manual": "Manual",
      "phone": "Phone",
      "walk_in": "Walk-in",
      "facebook": "Facebook",
      "instagram": "Instagram",
      "whatsapp": "WhatsApp"
    }
  },
  "jobs": {
    "title": "Jobs",
    "create": "Create job",
    "creation": {
      "steps": "Job creation steps",
      "customer": "Customer",
      "vehicle": "Vehicle",
      "details": "Booking details",
      "help": "Choose a customer and vehicle, then confirm the work and schedule.",
      "cancel": "Cancel",
      "choose_customer": "Choose customer",
      "choose_vehicle": "Choose vehicle",
      "change_customer": "Change customer",
      "change_selection": "Change customer or vehicle",
      "search_label": "Search by name, email or phone",
      "search": "Search",
      "clear_search": "Clear search",
      "no_customers": "No customers available at this location. Add a customer or use Customers to match and reuse an existing profile.",
      "no_matches": "No customers match your search. Try another name, email or phone, or clear the search.",
      "no_vehicles": "No vehicles available for this customer at this location. Add a vehicle or open their profile to reuse an existing vehicle.",
      "manage_customers": "Manage customers and reuse existing profiles",
      "manage_vehicles": "Open customer profile and reuse vehicles"
    },
    "new": "Confirm a job",
    "confirm": "Confirm job",
    "created": "Job confirmed.",
    "confirmed": "Confirmed job",
    "choose": "Choose…",
    "intake_help": "Confirm phone or walk-in work using the saved customer and vehicle. Customer email verification is not required.",
    "interval": "Bay and time",
    "bay_id": "Work bay",
    "starts_at": "Start",
    "ends_at": "End",
    "zone_help": "Enter local time at this location: {{zone}}.",
    "occurrence": "Repeated clock time",
    "first_occurrence": "First occurrence (UTC{{offset}})",
    "second_occurrence": "Second occurrence (UTC{{offset}})",
    "helpers": "Helpers (optional)",
    "team": "Team",
    "assignee_id": "Responsible assignee",
    "team_help": "Select one responsible team member. Helpers must be different people. Staff overlaps warn after confirmation.",
    "services": "Services",
    "quantity": "Quantity",
    "minutes": "{{count}} minutes",
    "no_services": "No available services. Ask an administrator to configure this location’s offerings.",
    "no_bays": "No available bays. Ask an administrator to configure a work bay.",
    "booking": "Booking details",
    "no_helpers": "None",
    "overlap": "Team overlap",
    "overlap_help": "A responsible assignee or helper also has work during this interval at this location. The job is confirmed; coordinate the team.",
    "net_minor": "Net",
    "tax_minor": "Tax",
    "total_minor": "Total",
    "terms_help": "These are the services, prices and customer details represented when the job was confirmed.",
    "progress": "Work, payment and collection",
    "work": "Work",
    "payment": "Payment",
    "collection": "Collection",
    "to_do": "To do",
    "unpaid": "Unpaid",
    "not_collected": "Not collected",
    "choose_vehicle": "Choose customer and vehicle",
    "entry_help": "Use Create job to choose a customer and vehicle, then confirm their booking.",
    "empty": "No confirmed jobs at this location.",
    "stale": "The customer, vehicle or service terms changed. Review the refreshed details and confirm again."
  },
  "bays": {
    "title": "Work bays",
    "description": "Configure the physical work spaces at this location. Reservations continue through nights and closed hours.",
    "add": "Add bay",
    "edit": "Edit bay",
    "edit_named": "Edit {{name}}",
    "name": "Bay name",
    "availability": "Availability",
    "enabled": "Available for new reservations",
    "disabled": "Unavailable for new reservations",
    "availability_help": "Existing reservations remain in place when a bay is made unavailable.",
    "empty": "No work bays configured yet.",
    "hold_hours": "Proposal hold duration (hours)",
    "hold_help": "New proposal holds expire after this many elapsed hours. Existing holds keep their disclosed expiry.",
    "hold_summary": "New proposal holds last {{hours}} hours.",
    "configure_hold": "Configure hold duration"
  },
  "inventory": {
    "title": "Inventory",
    "add": "Add product",
    "edit": "Edit product name",
    "name": "Product name",
    "unit": "Unit",
    "litre": "Litres",
    "piece": "Pieces",
    "unit_locked": "The unit stays fixed so earlier stock quantities keep their meaning.",
    "local_help": "Stock and its history belong to {{location}}.",
    "empty": "No detailing products recorded at this location.",
    "low_empty": "No products at or below their low-stock threshold.",
    "all": "All products",
    "low_only": "Low stock",
    "low": "Low stock",
    "normal": "Above threshold",
    "disabled": "Not set",
    "balance": "Available stock",
    "threshold": "Low-stock threshold",
    "save": "Save",
    "cancel": "Cancel",
    "history": "Stock history",
    "no_history": "No stock updates yet.",
    "receipt": "Record receipt",
    "correction": "Record physical count",
    "threshold_action": "Set low-stock threshold",
    "receipt_help": "Add the quantity actually received. This increases the current balance.",
    "correction_help": "Enter the total physically counted. This replaces the displayed balance; if stock changes meanwhile, review and retry.",
    "threshold_help": "Warn when stock is at or below this quantity. Leave blank to disable the warning.",
    "precision_litre": "Enter litres with up to three decimal places. A decimal comma or point is accepted.",
    "precision_piece": "Enter a whole number of pieces.",
    "quantity": "Quantity received",
    "count": "Total physical count",
    "reason": "Reason",
    "reason_help": "Explain the delivery, physical count or warning change for the team history.",
    "kind_receipt": "Receipt",
    "kind_correction": "Physical count correction",
    "kind_decrement": "Stock used",
    "kind_threshold": "Threshold change",
    "quantity_change": "{{before}} → {{after}} (change: {{change}})",
    "threshold_change": "Threshold: {{before}} → {{after}}",
    "by": "{{actor}} · {{time}}",
    "previous": "Previous",
    "next": "Next"
  },
  "services": {
    "title": "Services",
    "add": "Add service",
    "edit": "Edit service",
    "name": "Service name",
    "description": "Description",
    "save": "Save service",
    "configure": "Configure offering",
    "save_offering": "Save offering",
    "archive": "Archive service",
    "archived": "Archived",
    "available": "Available at this location",
    "unavailable": "Unavailable at this location",
    "empty": "No company services yet.",
    "shared_help": "Service names and descriptions are shared across the company. Earlier represented lines keep their original content.",
    "local_help": "Availability, prices, duration and configured tax below apply to {{location}}.",
    "archived_help": "This service is archived and cannot be selected for new work.",
    "unit_price": "Unit price",
    "currency": "Currency code",
    "estimated_minutes": "Estimated duration (minutes)",
    "tax_rate": "Configured tax rate (%)",
    "tax_label": "Tax label",
    "tax_mode": "Tax presentation",
    "inclusive": "Tax included",
    "exclusive": "Tax added",
    "amount_help": "Supported currencies: RON, USD, EUR and GBP. Enter prices with up to two decimal places and tax percentages with up to four. A comma or period may separate decimals; omit thousands separators. Tax is configured explicitly.",
    "price": "{{amount}} {{currency}}",
    "duration_few": "{{count}} minutes",
    "duration_one": "{{count}} minute",
    "duration_other": "{{count}} minutes"
  },
  "customer_portal": {
    "verification_title": "Verify your customer email",
    "confirmation_title": "Confirm your email",
    "password_title": "Create your customer password",
    "session_title": "Customer sign in",
    "verification_submit": "Send verification email",
    "confirmation_submit": "Verify email",
    "password_submit": "Create password",
    "session_submit": "Sign in",
    "email_address": "Email",
    "password": "Password",
    "password_confirmation": "Confirm password",
    "help": "Customer access is separate from staff sign in.",
    "password_help": "Your email is verified. Create a password of at least 12 characters to access history. Leaving this page preserves your verified email.",
    "sent": "Check your email for a verification link. The link expires in 24 hours.",
    "history": "Your customer history",
    "history_help": "Each company shares only the history explicitly authorized for you.",
    "empty": "No company history has been shared with you yet.",
    "companies": "All companies",
    "sign_out": "Sign out",
    "recording": "Authorized historical record",
    "recording_Customer": "Your customer profile",
    "invite": "Invite to customer history"
  },
  "vehicles": {
    "reuse": "Use existing vehicle",
    "reuse_help": "This customer has existing vehicles at another branch. Reuse a vehicle to add it here; earlier branch work and photos stay private.",
    "title": "Vehicles",
    "add": "Add vehicle",
    "edit": "Edit vehicle",
    "save": "Save vehicle",
    "details": "Vehicle details",
    "manual_help": "Choose a suggestion or type any make and model. Coverage is incomplete, including Romania and the US. Fabrication year is independent; other details are optional.",
    "catalogue_empty": "No suggestions. Keep typing to use your own value.",
    "catalogue_credit": "Vehicle data by",
    "catalogue_notices": "Source notices and changes",
    "catalogue_changes": "Names grouped and deduplicated by GarageClerk. No official endorsement.",
    "make": "Make",
    "model": "Model",
    "fabrication_year": "Fabrication year",
    "colour": "Colour",
    "registration_number": "Registration number",
    "vin": "Chassis / VIN",
    "photos": "Photos",
    "photo_help": "Keep up to 10 photos at this location and upload up to 10 per save. Use JPEG, PNG, WebP or GIF, at most 10 MB each. Existing photos stay unless selected for removal.",
    "remove_photo": "Remove {{name}} from this revision",
    "empty": "No vehicles for this customer at this location yet.",
    "owner": "Current owner",
    "owner_private": "Current owner is outside your location access.",
    "transfer": "Transfer ownership",
    "transfer_help": "Choose an existing customer at this location. Their access includes only their own records. Earlier owners keep their own history and photos. Current photos are kept only with the earlier owner; add new photos after transfer.",
    "new_owner": "New owner",
    "choose_owner": "Choose a customer",
    "no_owner": "No matching customers. Create or reuse a customer at this location first.",
    "reason": "Note (optional)",
    "confirm_transfer": "Confirm transfer",
    "search_owner": "Search customers by name",
    "search": "Search",
    "history": "Vehicle profile history",
    "history_help": "Profile actions at this location, with the details recorded then.",
    "actions": {
      "reused": "Existing vehicle added",
      "created": "Vehicle added",
      "edited": "Vehicle details changed",
      "transferred": "Ownership transferred"
    }
  },
  "customers": {
    "pages": "Customer pages",
    "page": "Page {{page}} of {{pages}}",
    "previous": "Previous",
    "next": "Next",
    "title": "Customers",
    "create": "Create customer",
    "edit": "Edit customer",
    "save": "Save customer",
    "details": "Customer details",
    "contact_required": "Enter a name and at least an email or phone. Address is optional.",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "address": "Address (optional)",
    "cancel": "Cancel",
    "choose": "Choose an existing customer",
    "reuse_help": "Use one customer with their saved details, or correct the contacts above and retry. Saved details will stay unchanged. Other branch history stays private.",
    "use_saved": "Use saved details",
    "matched": "Matched contact",
    "not_supplied": "Not supplied",
    "empty": "No customers at this location yet.",
    "phone_help": "Use an international number, for example +40712345678 or 0040712345678."
  },
  "maps": {
    "title": "Address and pin preview",
    "unavailable": "Map preview is unavailable. You can still save this address.",
    "address_hint": "Enter an address to preview its pin.",
    "notice": "Check that the pin matches your location before saving.",
    "interval_add": "Add interval",
    "interval_remove": "Remove interval"
  },
  "companies": {
    "no_location_title": "No location access",
    "no_location_description": "Ask a company administrator for location access, or switch to another company.",
    "new_identity": "Create a staff sign-in",
    "switch": "Switch company",
    "join_title": "Join company",
    "join_description": "Accept this invitation with your existing staff identity.",
    "invited_as": "{{email}} · {{role}}",
    "accept": "Accept invitation",
    "wrong_identity": "Sign out and sign in with the invited email address."
  },
  "recovery": {
    "expired": "Expired",
    "term_ended": "Term ended on {{date}}.",
    "paid_terms": "{{plan}}, {{amount}} per {{interval}}.",
    "trial_title": "Your trial has expired",
    "trial_description": "Subscribe to continue using your account.",
    "payment_title": "Update your subscription",
    "payment_description": "Your payment failed or your paid term has expired. Update payment to continue. During payment retries you can return to work after acknowledging this notice.",
    "upgrade": "Upgrade",
    "update_payment": "Update Payment",
    "subscribe": "Subscribe",
    "delete_account": "Delete account",
    "logout": "Log out",
    "contact_title": "Subscription required",
    "contact_description": "Contact an account administrator to restore access.",
    "closure_description": "Closing this account immediately removes access for every member and cancels recurring subscriptions. App data is permanently deleted after 30 days, once cancellation is confirmed. This cannot be reopened through the app.",
    "confirm_name": "Type {{name}} to confirm"
  },
  "common": {
    "account": "Account",
    "activity": "Activity",
    "add": "Add",
    "back": "Back",
    "billing": "Billing",
    "cancel": "Cancel",
    "continue": "Continue",
    "dashboard": "Dashboard",
    "language": "Language",
    "locations": "Locations",
    "password": "Password",
    "profile": "Profile",
    "save": "Save",
    "saving": "Saving...",
    "schedule": "Schedule",
    "settings": "Settings",
    "sign_out": "Sign out",
    "team": "Team",
    "location": "Location",
    "close": "Close",
    "more": "More",
    "loading": "Loading",
    "sidebar": "Navigation",
    "sidebar_description": "Application navigation",
    "toggle_sidebar": "Toggle navigation",
    "breadcrumb": "Breadcrumb"
  },
  "auth": {
    "continue_google": "Continue with Google",
    "email": "Email address",
    "forgot_password": "Forgot your password?",
    "forgot_description": "Reset your password",
    "forgot_title": "Forgot password",
    "has_account": "Already have an account?",
    "joining": "You are joining {{account}}",
    "login": "Sign in",
    "no_account": "Need an account?",
    "password": "Password",
    "password_confirmation": "Confirm password",
    "reset_submit": "Reset password",
    "reset_title": "Reset your password",
    "save_password": "Save password",
    "create_password": "Create a new password",
    "signup": "Create account",
    "signup_description": "Create a new account",
    "signup_title": "Sign up",
    "welcome": "Welcome",
    "login_title": "Login",
    "login_description": "Login to your account",
    "or": "Or"
  },
  "onboarding": {
    "account": "Account",
    "account_name": "Account name",
    "first_name": "First name",
    "last_name": "Last name",
    "location": "First location",
    "location_name": "Location name",
    "plan": "Plan",
    "profile": "Profile",
    "title": "Set up your workspace",
    "team_size": "Team size",
    "required": "Complete all required fields.",
    "trial_notice": "Start a {{days}}-day trial with {{plan}} features. Secure checkout collects a payment method; {{amount}} per {{interval}} for {{post_plan}} follows the trial. You can cancel in Billing before the trial ends.",
    "checkout": "Continue to secure checkout",
    "step": "Step {{current}} of {{total}}"
  },
  "settings": {
    "account_description": "Manage the shared details for this account.",
    "activity_description": "Review important account and location changes.",
    "billing_description": "Manage your subscription, invoices, and payment platform connection.",
    "location_description": "Manage this location's address, currency, and time zone.",
    "profile_description": "Update your personal details, avatar, and appearance.",
    "schedule_description": "Set the regular opening hours for this location.",
    "team_description": "Invite people, assign roles, and control location access."
  },
  "team": {
    "invite_title": "Invite a team member",
    "invite_description": "Choose a role and at least one location.",
    "email": "Email",
    "role": "Role",
    "admin": "Admin",
    "manager": "Manager",
    "member": "Member",
    "inactive": "Inactive",
    "send_invitation": "Send invitation",
    "save_role": "Save role",
    "active_access": "Active locations · operational access",
    "retired_history_access": "Retired locations · read-only history access",
    "retired_history_help": "Existing history permissions are preserved when active access changes. Uncheck a retired location and save access to revoke its history and reports. Administrators retain company-wide history. This never reactivates a location.",
    "save_access": "Save access",
    "reactivate": "Reactivate",
    "deactivate": "Deactivate",
    "pending_invitations": "Pending invitations"
  },
  "billing_ui": {
    "month": "month",
    "current_plan": "Current plan",
    "choose_plan": "Choose plan",
    "open_portal": "Open customer portal",
    "invoices": "Invoices",
    "no_invoices": "No invoices yet.",
    "plans": {
      "starter": {
        "name": "Start",
        "description": "For one active team member at one location."
      },
      "team": {
        "name": "Plus",
        "description": "For up to five active team members, roles and a custom domain."
      },
      "business": {
        "name": "Pro",
        "description": "For up to thirty active team members, unlimited locations and company-wide activity."
      }
    },
    "annual_total": "{{amount}} per year, billed annually.",
    "staff_limit": "Active staff: {{count}}",
    "location_limit": "Active locations: {{count}}",
    "unlimited_locations": "Unlimited active locations",
    "features": {
      "detailing_history": "Detailing history",
      "integrations": "Supported integrations",
      "custom_domains": "Custom domain",
      "invitations": "Invitations",
      "user_roles": "User roles",
      "multiple_locations": "Multiple locations",
      "activity_logs": "Company-wide activity console"
    },
    "monthly": "month",
    "yearly": "year",
    "trial_end": "Trial ends on {{date}}.",
    "next_bill": "Next billing date: {{date}}.",
    "cancels": "Your subscription ends at the end of the current period.",
    "start_trial": "Start {{days}}-day trial",
    "unavailable": "Billing is not configured for this environment. Contact your administrator.",
    "future_terms": "After the trial: {{plan}}, {{amount}} per {{interval}}.",
    "trial_features": "Your trial includes {{plan}} features.",
    "statuses": {
      "trialing": "Trial",
      "active": "Active",
      "past_due": "Payment overdue",
      "unpaid": "Unpaid",
      "canceled": "Canceled",
      "incomplete": "Incomplete",
      "incomplete_expired": "Expired",
      "paused": "Paused",
      "paid": "Paid",
      "open": "Open",
      "draft": "Draft",
      "void": "Void",
      "uncollectible": "Uncollectible"
    }
  },
  "activity_ui": {
    "all_actions": "All actions",
    "all_actors": "All actors",
    "all_locations": "All locations",
    "all_subjects": "All subjects",
    "action": "Action",
    "from_date": "From date",
    "to_date": "To date",
    "system": "System",
    "empty": "No activity yet.",
    "previous": "Previous",
    "next": "Next",
    "subjects": {
      "Account": "Account",
      "User": "User",
      "Location": "Location",
      "Invitation": "Invitation"
    }
  },
  "profile_ui": {
    "choose_image": "Choose image",
    "no_image": "No image selected",
    "avatar": "Avatar",
    "appearance": "Appearance",
    "light": "Light",
    "dark": "Dark",
    "system": "System",
    "save_appearance": "Save changes",
    "sessions": "Sessions",
    "unknown_browser": "Unknown browser",
    "current_session": "Current session",
    "revoke": "Revoke"
  },
  "fields": {
    "name": "Name",
    "address_line_1": "Address line 1",
    "address_line_2": "Address line 2",
    "city": "City",
    "region": "Region",
    "postal_code": "Postal code",
    "country_code": "Country",
    "currency": "Currency",
    "time_zone": "Time zone",
    "logo": "Account logo",
    "current_password": "Current password"
  },
  "countries": {
    "RO": "Romania",
    "US": "United States",
    "GB": "United Kingdom",
    "DE": "Germany"
  },
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "schedule_ui": {
    "closed": "Closed",
    "opens_at": "Opening time",
    "closes_at": "Closing time",
    "toggle": "Open on {{day}}"
  },
  "locations_ui": {
    "description": "Create locations and manage their settings.",
    "add": "Add location",
    "new_description": "Add a location for your team.",
    "limit": "Your current plan location limit has been reached."
  },
  "connect_ui": {
    "country": "Legal business country",
    "select_country": "Select a country",
    "country_help": "Choose where this legal business is established. Stripe will verify its details during onboarding.",
    "romania": "Romania",
    "united_states": "United States",
    "title": "Stripe Connect",
    "ready": "Charges and payouts are enabled.",
    "description": "Connect an account to receive payments.",
    "continue": "Continue Stripe setup",
    "start": "Connect with Stripe",
    "unavailable": "Stripe is not configured for this environment.",
    "restricted": "Stripe needs additional information. Continue setup to review requirements."
  },
  "reschedules": {
    "title": "Reschedule confirmed job",
    "original": "Original confirmed booking",
    "replacement": "Proposed replacement",
    "reason": "Reason for rescheduling",
    "communication": "Customer communication",
    "communication_help": "Record how you informed the customer (phone, in person or an existing channel). Share the review link after holding the replacement. No message is sent automatically.",
    "keep_original": "Your original booking stays confirmed until you accept this replacement. Rejection, an alternative suggestion or expiry keeps the original booking.",
    "deadline": "Replacement held until {{expiry}}.",
    "pending_status": "Awaiting customer decision. Original booking retained.",
    "accepted_status": "Replacement accepted. The confirmed booking has moved to the displayed replacement.",
    "declined_status": "Replacement declined. Original booking retained.",
    "rescheduled_status": "Alternative requested. Replacement released; original booking retained.",
    "superseded_status": "Offer superseded by a recorded job change. Replacement capacity released.",
    "expired_status": "Replacement expired. Original booking retained.",
    "propose": "Hold replacement and record communication",
    "link": "Customer review link",
    "open": "Review reschedule",
    "accepted": "Accept replacement",
    "declined": "Keep original booking",
    "rescheduled": "Suggest another time",
    "counter_help": "Your suggestion reserves no alternative. The proposed replacement will be released; the original booking stays confirmed.",
    "suggested": "Customer alternative: {{time}}",
    "unchanged_terms": "Unchanged services, prices and team",
    "close_expired": "Close expired offer",
    "expired_at": "Replacement expired at {{expiry}}."
  },
  "calendar": {
    "title": "Calendar",
    "help": "Seven location-calendar days in {{zone}}. Appointments retain their agreed timezone.",
    "week_from": "Week starting",
    "show": "Show week",
    "navigation": "Calendar navigation",
    "previous": "Previous week",
    "today": "Today",
    "next": "Next week",
    "empty": "No appointments or active holds in this week.",
    "hold": "Proposed / held interval",
    "past": "Historical job",
    "current": "Current job",
    "future": "Future job",
    "occupied": "Bay occupied until ready for collection",
    "pages": "Calendar pages",
    "page": "Page {{page}} of {{pages}}"
  },
  "booking": {
    "help": "Choose a customer and vehicle, then schedule the detailing work.",
    "discard_profile": "Discard unsaved profile details?",
    "select_profiles": "Choose a customer and vehicle before confirming this job.",
    "saving": "Saving…",
    "summary": "Booking summary",
    "draft_help": "Your booking details stay in this draft while you add or change profiles.",
    "quick_customer": "Save a customer and return to this booking.",
    "quick_vehicle": "Save a vehicle and return to this booking.",
    "changed_terms": "This service changed. Review the current price, duration and taxes before accepting the updated terms.",
    "previous_terms": "Previously selected",
    "accept_terms": "Accept updated service terms",
    "removed_services": "No longer available: {{names}}. Choose a replacement or confirm removal.",
    "confirm_removal": "Confirm service removal"
  },
  "customer_workspace": {
    "search": "Search by name, email or phone",
    "scope": "Work at {{location}}",
    "no_jobs": "No jobs at this location yet.",
    "no_requests": "No requests at this location yet."
  },
  "vehicle_workspace": {
    "service_history": "Service history",
    "no_visits": "No recorded visits at this location yet."
  },
  "integrations": {
    "title": "Integrations",
    "description": "Connect accounts owned by your company. Available on every plan; provider charges and permissions may apply. Connecting does not purchase a provider subscription.",
    "test": "Test invoice connections",
    "default": "Future invoices: {{provider}}",
    "default_help": "Successful setup of another invoice provider changes future invoices. Existing invoices keep their provider. Failures wait for retry and never switch providers automatically.",
    "pending": "{{count}} invoice request(s) need attention or are waiting for retry. Open the job invoices to review or retry.",
    "unavailable": "Connection setup is not available yet. Your current invoice provider stays selected.",
    "updated": "Connection checked.",
    "disconnected": "Connection disconnected. Your invoice default is unchanged.",
    "series": "Existing invoice series",
    "choose_series": "Choose an existing series",
    "save_series": "Verify and use series",
    "guide": "{{provider}} guide",
    "connect": "Connect {{provider}}",
    "disconnect": "Disconnect {{provider}}",
    "categories": {
      "payment_invoice": "Payments and invoicing",
      "invoice": "Invoicing",
      "reporting": "Fiscal reporting",
      "messaging": "Messaging"
    },
    "states": {
      "ready": "Connected and verified",
      "series": "Choose an existing invoice series to complete setup",
      "unverified": "Awaiting verification",
      "unavailable": "Verification unavailable",
      "disconnected": "Not connected"
    },
    "help": {
      "stripe": "The initial invoice provider. Payment collection and invoice readiness are checked separately from your GarageClerk subscription.",
      "smartbill": "Use your own SmartBill account with API access and existing invoice series.",
      "easybill_ro": "Use your own Romanian EasyBill.ro account. Provider access must be verified.",
      "ro_efactura": "Reports the same Stripe invoice with company authorization. It does not replace your invoice provider or issue another invoice.",
      "facebook": "Connect a company Facebook Page when messaging authorization is available.",
      "instagram": "Connect a company professional account when messaging authorization is available.",
      "whatsapp": "Connect your company WhatsApp Business account when messaging authorization is available."
    },
    "access_token": "Provider access token",
    "changed": "Connection changed during verification. Check the current setup and try again.",
    "dispatch": {
      "queued": "Invoice request queued. The selected provider will be used; no automatic fallback.",
      "running": "Invoice request in progress. An uncertain result will be reconciled before retry.",
      "waiting": "Invoice request is waiting for retry with its original provider. Check the connection or confirm again to retry.",
      "attention": "Invoice request needs attention. Check billing details and connection, then confirm again to retry."
    },
    "verified_on": "Last verified: {{date}}",
    "setup_unavailable": "Connection setup is not available yet."
  }
}
